import React from 'react';
import { Icon } from '../icon';
import classNames from 'classnames';
import InputSearch from '../input/Search';
import { ConfigContext } from '../config-provider';
import AnimationContext from '../config-provider/AnimationContext';
import warning from 'antd/es/_util/warning';
import AntdConfigProvider from 'antd/es/config-provider';
const Search = React.forwardRef((props, ref) => {
    const { className, enterButton, brandType, bordered, ...otherProps } = props;
    const { disabled } = props;
    const { getPrefixCls, ...restContext } = React.useContext(ConfigContext);
    const animation = React.useContext(AnimationContext);
    const prefixCls = getPrefixCls('input', props.prefixCls);
    const newenterButton = !enterButton ? React.createElement(Icon, { type: 'search' }) : enterButton;
    if (process.env.NODE_ENV !== 'production')
        warning(props.bordered !== false, 'Search', `'bordered = false' is deprecated now`);
    warning(!('theme' in props), 'Search', `'themes = gray' is deprecated in B-Design 3.0`);
    const newClassName = classNames(className, {
        [`${prefixCls}-search-brand`]: brandType,
        [`${prefixCls}-search-disabled`]: disabled,
        [`${prefixCls}-breathing`]: !!animation?.breathing && !brandType
    });
    return (React.createElement(AntdConfigProvider, { prefixCls: getPrefixCls('', props.prefixCls), ...restContext },
        React.createElement(InputSearch, { bordered: true, ...otherProps, enterButton: newenterButton, className: newClassName, ref: ref })));
});
Search.defaultProps = {
    size: 'middle'
};
Search.displayName = 'Search';
// const ConfiguredSearch = withConfigProvider(Search);
// export { ConfiguredSearch as Search };
// export default ConfiguredSearch;
export { Search };
export default Search;
